export const GET_LOCATION = 'get_location';
export const GET_LOCATIONS_SUCCESS = 'get_locations_success';
export const SELECTED_LOCATION_SUCCESS = 'selected_location_success';
export const REGISTER_PATIENT = 'register_patient';
export const GET_SELECTED_PATIENT = 'get_selected_patient';
export const GET_SELECTED_PATIENT_SUCCESS = 'get_selected_patient_success';
export const GET_WELCOME_CENTER_SCREEN = 'get_welcome_center_screen';
